module.exports = __webpack_public_path__ + "img/pos4-bg.1baef2cd.jpg";